(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cedra-payment-choices"] && !Shopify.designMode) return;
  try {
    (function () {
    async function continueToCheckout(button) {
      var container = button.closest('[data-cedra-payment-choices]');
      var form = button.closest('form[action*="/cart/add"]');
      var status = container ? container.querySelector('[data-cedra-payment-status]') : null;
      var buttons = container ? container.querySelectorAll('[data-cedra-payment-method]') : [];
      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

      if (!form) {
        if (status) status.textContent = 'No pudimos identificar el producto. Recarga la página e inténtalo nuevamente.';
        return;
      }

      buttons.forEach(function (item) { item.disabled = true; });
      if (status) status.textContent = 'Preparando checkout seguro…';

      try {
        var addResponse = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(form)
        });

        if (!addResponse.ok) throw new Error('add_to_cart_failed');

        await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Método de pago preferido': button.getAttribute('data-cedra-payment-method')
            }
          })
        });

        window.location.assign(root + 'checkout');
      } catch (error) {
        buttons.forEach(function (item) { item.disabled = false; });
        if (status) status.textContent = 'No se pudo iniciar el pago. Inténtalo de nuevo o usa Añadir al carrito.';
      }
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cedra-payment-method]');
      if (!button) return;
      event.preventDefault();
      continueToCheckout(button);
    });
  }());
  } catch(e) { console.error(e); }
})();

})();
